import { initMemberNav } from './member-nav.js';

initMemberNav(jQuery);
